import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage, useFormikContext } from 'formik';
import { hideLoading, showLoading } from '../../lib/uiService';
import ManualBonusService from '../../services/manualBonus.service';
import ManualBonusForm from '../../components/Bonuses/ManualBonusForm';
import useErrorHandling from '../../hooks/useErrorHandling';
import { object, string, number } from 'yup';
import { toast } from 'react-toastify';

const ManualBonus: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const [bonusData, setBonusData] = useState<any>({
    periodType: 'month',
    year: currentYear,
    monthBitmask: 1 << 0,
    description: '',
  });
  const { setError } = useErrorHandling();
  const { manualBonusId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (manualBonusId) {
      getManualBonus(manualBonusId);
    }
  }, [manualBonusId]);

  const getManualBonus = (id: any) => {
    showLoading();
    ManualBonusService.GetManualBonus(id)
      .then((res) => {
        const data = res?.manualBonus;
        setBonusData(data);
        hideLoading();
      })
      .catch((error) => {
        hideLoading();
        setError(error.status);
      });
  };

  const validation = object().shape({
    periodType: string().required('Required'),
    year: number().required('Required').min(2020).max(2100),
    monthBitmask: number().required('Required'),
    description: string(),
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [initialValues, setInitialValues] = useState<any>(null);
  useEffect(() => {
    setInitialValues(bonusData);
  }, [bonusData]);

  const onSubmit = async (values: any) => {
    setIsSubmitting(true);
    try {
      // Build period info for backend
      const bonus: any = {
        periodType: values.periodType,
        monthBitmask: values.monthBitmask,
        year: values.year,
        description: values.description,
        manualBonusUsers: values.manualBonusUsers || [],
      };
      if (!manualBonusId) {
        const res = await ManualBonusService.CreateManualBonus(bonus);
        const manualBonusId = res?.manualBonus?.manualBonusId;
        window.location.href = `/manual-bonus/${manualBonusId}`;
      } else {
        await ManualBonusService.EditManualBonus(manualBonusId, bonus);
        toast.success('Bonus updated successfully');
        // Fetch latest bonus data to reset form and disable Save button
        // getManualBonus(manualBonusId);
        window.location.href = `/manual-bonus`;
      }
    } catch (error) {
      toast.error(error?.response?.data?.error || 'Error saving bonus');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Formik initialValues={bonusData} validationSchema={validation} onSubmit={onSubmit} enableReinitialize>
      {(formikProps) => (
        <ManualBonusForm
          bonusData={bonusData}
          manualBonusId={manualBonusId}
          isSubmitting={isSubmitting}
          isDirty={formikProps.dirty}
        />
      )}
    </Formik>
  );
};

export default ManualBonus;
